import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationWaitLogEntry } from 'lib-shared-types-api';

import { durationConverter } from 'utils/duration';
import { useShortHumanReadableTimer } from 'utils/useShortHumanReadableTimer';

type RoutedThroughWaitProps = {
  node: ConversationAutomationWaitLogEntry;
};

export function RoutedThroughWait({
  node,
}: RoutedThroughWaitProps): JSX.Element {
  const { delay_in_seconds: delayInSeconds, event_timestamp: waitStarted } =
    node;

  const waitStartedDate = new Date(waitStarted);
  const waitTimeLeft = Math.max(
    0,
    delayInSeconds * 1000 - Math.floor(Date.now() - waitStartedDate.getTime()),
  );

  const humanTimeLeft = useShortHumanReadableTimer(Date.now() + waitTimeLeft);

  const humanDelay = durationConverter.toString(delayInSeconds);

  if (waitTimeLeft > 0) {
    return (
      <Text.Paragraph>
        {`Wait · Automation will continue ${
          humanTimeLeft === 'just now' ? 'in a few seconds' : humanTimeLeft
        } from now`}
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>
      {`Wait · Automation waited for ${humanDelay}`}
    </Text.Paragraph>
  );
}
